(function() {
  'use strict';

  angular
    .module('app', [
      'ngCordova',
      'ngAnimate', 
      'ngCookies',  
      'ngSanitize', 
      'ngMessages', 
      'ngAria', 
      'ui.router', 
      'ngMaterial', 
      'toastr', 
      'LocalStorageModule', 
      'ngFileUpload',
      'ngWig', 
      'textAngular',
      'ngFileUpload'
  ]);

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('addCompanyController', addCompanyController);

  /** @ngInject */
  function addCompanyController( companies, qs, $mdDialog  ) {
      var vm = this;
	  
	  vm.companies = companies;

	  vm.close = function() { $mdDialog.hide(); }
   
	  vm.submit = function() {
		  //do smth then
		 $mdDialog.hide();
	  }
  
  }
    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.users', {
            url: '/users',
            views: {
                'content@index': {
                    templateUrl: "app/states/users/main.tpl",
                    controller: 'UsersController',
                    controllerAs: 'vm',
                    resolve: {
                        users: function(qs) {
                             return qs.get('users')
                            .then(function(response){
                                return response.data.result;
                            })
                        },
						companies: function(qs) {
							return qs.get('companies')
							.then(function(r) {
								return r.data.result;
							})
						}
                    }
               
                }
            }
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('UsersController', UsersController);

  /** @ngInject */
  function UsersController( users, companies, qs, gmDialog, $mdDialog  ) {
      var vm = this;

	  angular.forEach(users, function(e,i) {
		  users[i].company = companies.filter(function(item) { return item.id == e.company})[0];
	  })
	  
    vm.users = users;


   
  
  }
    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.user', {
            url: '/user/:id',
            views: {
                'content@index': {
                    templateUrl: "app/states/user/main.tpl",
                    controller: 'UserController',
                    controllerAs: 'vm',

                }
            },
			resolve: {
				user: function ( qs, $stateParams ) {
					return qs.get('users', {key:'id', value: $stateParams.id })
					.then( function(r) {return r.data.result[0] || null ; })
				},
				userData: function(qs, user) {
					if ( user != null) {
						return qs.get('userData', {key:'uid', value: user.id})
						.then(function(r) { return r.data.result[0]; });
					} else { return {}; }
				},
				users: function (qs) {
					return qs.get('users')
					.then( function(r) { return r.data.result; })
				},
				companies: function (qs) {
					return qs.get('companies')
					.then( function(r) { return r.data.result; })
				},	
				apps: function (qs) {
					return qs.get('apps')
					.then( function(r) { return r.data.result; })
				},	
				roles: function (qs) {
					return qs.get('roles')
					.then( function(r) { return r.data.result; })
				},
				counties: function(countryService) {
					return countryService.counties()
					.then(function(r) { return r.data.result;})
				},
				subscriptions: function(qs) {
					return qs.get('subscriptions')
					.then(function(r) { return r.data.result;})
				}				
				
			}
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('UserController', UserController);

  /** @ngInject */
  function UserController( $state,  qs, gmDialog, $mdDialog, user, userData, subscriptions, users, companies, apps, roles, counties, userService, $q) {
      var vm = this;

	  vm.user = user;

	 
	  vm.userData = userData || {};

	  vm.companies = companies;
	  vm.apps = apps;
	  vm.roles = roles;
	  vm.counties = counties;
	  vm.cities = [];


	  if ( vm.user != null ) {
		  //initial departments
	  	  qs.get('departments', {key:'company', value: user.company}).then(function(r) { vm.departments = r.data.result;})		
		  // initial cities
		  if ( typeof vm.userData.county != "undefined") {
			  qs.get('localitati', {key:'county_id', value: userData.county}).then(function(r) { vm.cities = r.data.result; });
		  }
		  
	  }	else {
		  vm.user = {}; 
		  vm.userData = {};
	  }  
	  
	  
	  vm.companyChange = function(cid) {
		  qs.get('departments', {key:'company', value:cid})
		  .then(function(r) {
			  vm.departments = r.data.result;
			  vm.user.department = vm.departments[0].id;
		  })
	  } 
	  
	  vm.countyChange = function(jId) {
		  qs.get('localitati', {key:'county_id', value: jId})
		  .then(function(r) { vm.cities = r.data.result; })
		  
	  }
	  
	  vm.submit = function() {
		  //create resource
		  if (typeof vm.user.id == "undefined") {
			  userService.create(vm.user)
			  .then(function(r) {
				  var id = r.data.msg;
				  var userDetails = angular.copy(vm.userData);
				  userDetails.uid = id;
				  qs.create('userData', userDetails)
				  .then(function() {
					  gmDialog.alert("SUCCES", "Utilizatorul a fost creat cu succes", "OK")
					  .then(function() { $state.go('index.users'); })
				  })
			  })
		  } else {
		  // otherwise update resource

		if ( vm.user.password != null && vm.user.password.length > 30 ) { delete(vm.user.password);}
              
		  userService.update(vm.user)
			.then(function(r) { 
		  	qs.update('userData', vm.userData)
			  .then(function(r) {
					  gmDialog.alert("SUCCES", "Utilizatorul a fost actualizat cu succes", "OK")
					  .then(function() { $state.go('index.users'); })				
			})
		  })
		  
		  }
	  }
	  
	  vm.remove = function() {
		  gmDialog.prompt("x","ATENȚIE","Veți șterge utilizatorul " + vm.user.name + "!", "CONFIRMĂ", "ANULEAZĂ")
		  .then(function(r){
			  if ( typeof r !== "undefined" && r.toLowerCase() == "da") {
				  var q = [];
				  q.push(userService.remove(vm.user.id));
				  q.push(qs.smartRemove('userData', 'uid', vm.user.id));
				  q.push(qs.smartRemove('subscriptions', 'uid', vm.user.id));
				  
				  var prms = $q.all(q);
				  prms.then( function () {
					  	gmDialog.alert('', 'Utilizatorul '+ vm.user.username +' a fost șters cu succes!', "INCHIDE")
						  .then(function() { $state.go('index.users'); });					  
				  })
			  }
		  });
	  }

   
  
  }
    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.subscriptions', {
            url: '/subscriptions',
            views: {
                'content@index': {
                    templateUrl: "app/states/subscriptions/main.tpl",
                    controller: 'SubscriptionsController',
                    controllerAs: 'vm',
                    resolve: {
                        subs: function(qs) {
                             return qs.get('subscriptions')
                            .then(function(response){
                                return response.data.result || [];
                            })
                             
                        },
						apps: function(qs) {
							return qs.get('apps')
							.then(function(r) {
								return r.data.result || [];
							})
						},						
						companies: function(qs) {
							return qs.get('companies')
							.then(function(r) {
								return r.data.result || [];
							})
						},
						users: function(qs) {
							return qs.get('users')
							.then(function(r) {
								return r.data.result || [];
							})
						}						
                    }
               
                }
            }
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('SubscriptionsController', SubscriptionsController);

  /** @ngInject */
  function SubscriptionsController( subs, companies, users,apps, qs, gmDialog, $mdDialog  ) {
      var vm = this;

	  vm.apps = apps;
	  vm.companies = companies;
	  vm.users = users;
	  
	  
	  angular.forEach(subs, function(e,i) {
		  
		  subs[i].user = users.filter(function(item) { return item.id == e.uid})[0];
		  if ( typeof subs[i].user !== "undefined") {
			   subs[i].company = companies.filter(function(item) { return item.id == subs[i].user.company})[0];
			   subs[i].app = apps.filter(function(item) { return item.id == subs[i].appId})[0];
		  }
		 
	  })
	  
    vm.subs = subs;


   
  
  }
    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.subscription', {
            url: '/subscription/:id',
            views: {
                'content@index': {
                    templateUrl: "app/states/subscription/main.tpl",
                    controller: 'SubscriptionController',
                    controllerAs: 'vm',

                }
            },
			resolve: {
				item: function ( qs, $stateParams ) {
					return qs.get('subscriptions', {key:'id', value: $stateParams.id })
					.then( function(r) { return r.data.result[0] || null ; })
				},
				users: function (qs) {
					return qs.get('users')
					.then( function(r) { return r.data.result; })
				},
				companies: function (qs) {
					return qs.get('companies')
					.then( function(r) { return r.data.result; })
				},	
				apps: function (qs) {
					return qs.get('apps')
					.then( function(r) { return r.data.result; })
				},	
				roles: function (qs) {
					return qs.get('roles')
					.then( function(r) { return r.data.result; })
				}				
				
			}
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('SubscriptionController', SubscriptionController);

  /** @ngInject */
  function SubscriptionController( item , companies, users, apps, roles, gmDialog, $state, qs ) {
      var vm = this;
	  
	  vm.item = item;

	  vm.companies = companies;
	  vm.users = users;
	  vm.apps = apps;
	  vm.roles = roles;

	  
	  //intialize company in edit mode
	  if (item != null) {
		 var comp  = users.filter(function(item) { return item.id == vm.item.uid });
		  comp.length > 0 ? vm.cid = comp[0].company : vm.cid = null;
		  
	  }
	  
   	 //get users of certain company
	  vm.changeCompany = function( uid ) { 
	  	vm.cid = users.filter(function(item) { return item.id == uid })[0].company;
	  }
  
	  
	  //date and interval shit
	  if (item != null) {
		  vm.startDate = moment(item.startDate*1000).toDate();
		  vm.endDate = moment(item.endDate*1000).toDate();
		  vm.interval = parseInt(moment.duration(moment(vm.endDate).diff(moment(vm.startDate))).asMonths());
		  
	  }  else {
		  vm.startDate = new Date();
		  vm.item = {};
		  vm.item.startDate = moment(vm.startDate).unix();	
		  
		  vm.interval = 12;
		  vm.endDate = moment(vm.startDate).add(vm.interval, 'M').toDate();
	  }

	  vm.changeStartDate = function(date) {
		  vm.endDate = moment(date).add(vm.interval, 'M').toDate();
		  vm.item.startDate = moment(vm.startDate).unix();	
		  vm.item.endDate = moment(vm.endDate).unix();	

		  
	  }
	  vm.changeEndDate = function(date) {
		  vm.interval = parseInt(moment.duration(moment(date).diff(moment(vm.startDate))).asMonths());
		  vm.item.startDate = moment(vm.startDate).unix();	
		  vm.item.endDate = moment(vm.endDate).unix();			  
	  }
	  vm.changeInterval = function(months) {
		  vm.endDate = moment(vm.startDate).add(months,'M').toDate();
		  vm.item.startDate = moment(vm.startDate).unix();	
		  vm.item.endDate = moment(vm.endDate).unix();			  
		  
	  }
	  
	vm.confirm = function() {
		
		var post = angular.copy(vm.item);
		
		post.startDate = moment(vm.startDate).unix();
		post.endDate = moment(vm.endDate).unix();

		if ( typeof post.id === "undefined" ) {
			console.log("create");
			qs.create('subscriptions', post)
			.then(function() {
				gmDialog.alert("SUCCES!", "Abonamentul a fost creat cu succes!", "ÎNCHIDE")
				.then(function(r) {
					if ( r == true ) {
						$state.go('index.subscriptions');
					} 
				})
			})
		} else {
			qs.update('subscriptions', post)
			.then(function() {
				gmDialog.alert("SUCCES!", "Abonamentul a fost actualizat cu succes!", "ÎNCHIDE")
				.then(function(r) {
					if ( r == true ) {
						$state.go('index.subscriptions');
					} 
				})				
			})
		}
	}
	
	
	vm.remove = function() {
		console.log("sterge");	
		qs.remove('subscriptions', {id:vm.item.id})
		.then(function(r) {
			if ( r.data.msg.ok = true) {
				gmDialog.alert("SUCCES", "Stegerea abonamentului a fost realizată cu succes!", "ÎNCHIDE")
				.then(function(rs){
					if (rs == true) {
						$state.go("index.subscriptions");
					}
				} )
			}
		})
	}
	
	
  }
	

    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.roles', {
            url: '/roles',
            views: {
                'content@index': {
                    templateUrl: "app/states/roles/main.html",
                    controller: 'RolesController',
                    controllerAs: 'vm',
                    resolve: {
                        roles: function(qs) {
                             return qs.get('roles')
                            .then(function(response){
                                return response.data.result;
                            })
                             
                        }
                    }
               
                }
            }
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('RolesController', RolesController);

  /** @ngInject */
  function RolesController( roles, qs, gmDialog, $mdDialog  ) {
      var vm = this;

    vm.roles = roles;

    vm.confirm = function(item) {
          qs.update('roles', item)
            .then(function(r) {
              gmDialog.alert("SUCCES!", "Ati actualizat cu succes rolul "+item.roleName, "ÎNCHIDE" )
          })
      }
    
      vm.action = function(item) {
          var modal = $mdDialog.show({
              controller: "RoleModalController",
              controllerAs: "vm",
              templateUrl: "app/states/roles/RoleModalTemplate.html",
              clickOutsideToClose: true,
			  locals: { item: item}
          });
		  
		  modal.then(function(r) {
			  if ( r.action == "create" ) {
				  console.log(r.data);
				  qs.create('roles', r.data)
				  .then(function(resp) { if ( resp.data.ok == true) {
					  r.data.id = resp.data.msg;
					  gmDialog.alert("SUCCES!", "Rolul a fost creat!", "ÎNCHIDE")
					  .then(function() { vm.roles.push(r.data); 
									   console.log(vm.roles);
									   })
				  }})
			  }
			  if ( r.action == "update" ) {
				  console.log(r.data);
				  qs.update('roles', r.data)
				  .then(function(resp) { if ( resp.data.ok == true) {
					  gmDialog.alert("SUCCES!", "Rolul a fost actualizat!", "ÎNCHIDE");
				  }})
			  }			  
			  
			  if ( r.action == "remove") {
				  qs.remove("roles", {id:r.data.id})
				  .then(function() {
					  gmDialog.alert("SUCCES!", "Rolul a fost sters!", "ÎNCHIDE")
					  .then(function() {
						  vm.roles.splice(vm.roles.indexOf(r.data),1);
					  })
					  
				  })
			  }
			  

		  })
		  
      }
	  

    
 
      
    
   
  
  }
    

})();

(function () {
	'use strict';

	angular
		.module('app')
		.controller('RoleModalController', RoleModalController);

	/** @ngInject */
	function RoleModalController(qs, $mdDialog, item) {
		var vm = this;

		vm.item = item;

		vm.action = function (action,data) {

			$mdDialog.hide({ action: action, data: vm.item });

		}


	}




})();
(function () {
    'use strict';

    angular
        .module('app')
        .controller('LoginController', LoginController)
        .controller('LogoutController', LogoutController);

    /** @ngInject */
    function LoginController($log, authService, localStorageService, $state, APP) {
        var vm = this;
		vm.appData = APP;
        vm.submit = function (data) {
            authService.login(data).then(function (r) {
             console.log(r);
                if ( typeof r.result.uid != 'undefined') {
                    localStorageService.set('uid', parseInt(r.result.uid));
                    localStorageService.set('apikey', r.result.hash);
                    localStorageService.set('user', r.result);
                    $state.go('index.main');
                }
            });
        }
        if (localStorageService.get('apikey') != null) {
            $state.go('index.main');
        }
    }

    function LogoutController($log, authService, localStorageService, $state) {
        authService.logout()
        .then(function() {
            localStorageService.remove('uid');
            localStorageService.remove('apikey');
            localStorageService.remove('user');
            $state.go('login');                 
        })
    }
        
    


})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $stateProvider


        .state('login', {
            url: '/login',
            templateUrl: 'app/states/login/loginForm.html',
            controller: 'LoginController',
            controllerAs: 'vm'
        })
        .state('logout', {
            url: '/logout',
            template: '<div></div>',
            controller: 'LogoutController',
            controllerAs: 'vm'
        })

    }

})();
(function() {
  'use strict';
  angular
    .module('app')
    .controller('ExceptionController', ExceptionController);
  /** @ngInject */
  function ExceptionController( errId, httpMessage) {
      
      var vm = this;
      
      
      
      vm.error = httpMessage.get(errId)[0];
      console.log("eroare", vm.error);
      
  }
})();
(function() {
  'use strict';

  angular
    .module('app')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {
    $stateProvider
      .state('exception', {
        url: '/exception/:id',
        templateUrl: 'app/states/exception/template.html',
        controller: 'ExceptionController',
        controllerAs: 'vm',
        resolve: {
            errId: function($stateParams) {
                return $stateParams.id;
            }
        }
        

      })
  }

    
})();
 
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.company', {
            url: '/company/:id',
            views: {
                'content@index': {
                    templateUrl: "app/states/company/main.tpl",
                    controller: 'CompanyController',
                    controllerAs: 'vm',
                    resolve: {
						
                        data: function(qs, $stateParams) {
                             return qs.get('companies', {key:'id', value:$stateParams.id})
                            .then(function(response){
                                return response.data.result[0] ||  null;
                            })
                             
                        },
						county: function(countryService, data){
							if ( data != null ) {
								return countryService.countyById(data.county)
								.then(function(r) { return r.data.result[0];})							
							} else { return null; }
						},
						city: function(countryService, data){
							if ( data != null ) {
								return countryService.cityById(data.county)
								.then(function(r) { return r.data.result[0];})
							} else { return null;}
						},
						counties: function(countryService) {
							return countryService.counties()
							.then(function(r) { return r.data.result; })
						},
						cities: function(countryService, county) {
							if ( county != null ) {
							return countryService.citiesByCountyId(county.id)
							.then(function(r) { return r.data.result; })
							} else { return null; }
						},
						depts: function(qs, data) {
							if ( data != null ) {
								return qs.get('departments', {key:'company', value: data.id})
								.then(function(r) { return r.data.result; })
							} else { return null; }
						},
						users: function(qs, data) {
							if ( data != null) {
								return qs.get('users', {key:'company', value: data.id})
								.then(function(r) { return r.data.result; })								
							} else { return null; }

						}						
                    }
               
                }
            }
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('DeptController', DeptController);

  /** @ngInject */
  function DeptController( qs, $mdDialog, gmDialog, dept, company,$q , $state) {
      var vm = this;
	  vm.dept = dept;
	  vm.company = company;
	  vm.close = function() {$mdDialog.hide();}

	  vm.confirm = function() {
		 var post = angular.copy(vm.dept);
		  	 post.company = company.id;
		  
		  if ( typeof vm.dept.id == "undefined" ) {
			  //create
			  qs.create('departments', post)
			  .then(function(r) {
				 $mdDialog.hide({action:"create", id:r.data.msg});
				})
			  
		  } else {
			 //update
			  qs.update('departments', post)
			  .then(function(r) {
				 $mdDialog.hide({action:"update", id:dept.id});
				})			  
		  }		  
		  
	  }
	  
	  vm.remove = function(item) {
					qs.remove('departments', {id:item.id})
					.then(function() { 
						$mdDialog.hide({action:"delete", id: item.id});
					});
	  }
	  
  
  }
    

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('CompanyController', CompanyController);

  /** @ngInject */
  function CompanyController( $stateParams, $state, $mdDialog, gmDialog, countryService,  data , county, city, counties, cities, depts, users, qs, $q) {
      var vm = this;

    vm.data = data;
	vm.counties =  counties;
	vm.cities = cities;
	vm.depts = depts;
	vm.users = users;
	

    vm.changeJudet = function(item) {
		countryService.citiesByCountyId(item)
		.then(function(r) {
			vm.cities = r.data.result;
			vm.data.city = null;
		})
	}
	
	vm.department = function(dept) {
		console.log(dept);
		var modal = $mdDialog.show({
			templateUrl: 'app/states/company/DeptTemplate.tpl',
			controller: 'DeptController',
			controllerAs: 'vm',
			locals: {
				dept: dept,
				company: vm.data
			},
			clickOutsideToClose: true
		});
		modal.then(function(r) {
			
			if ( typeof r !== "undefined") {
				console.log("modal said",r.action, r.id);
				
				
				
				qs.get('departments', {key:'company', value: data.id})
				.then(function(resp) { vm.depts = resp.data.result; })
			}
		})
	}
	
	vm.confirm = function(item) {
		if ( typeof item.id === "undefined") {
			//create
			qs.create('companies', item).then(function(r) {
				gmDialog.alert("SUCCES!", "Compania " + item.name + " a fost creată cu succes!", "ÎNCHIDE")
				.then(function() { $state.go('index.companies')});
			})			
		} else { 
		//update
			qs.update('companies', item).then(function(r) {
				gmDialog.alert("SUCCES!", "Compania " + item.name + " a fost actualizată cu succes!", "ÎNCHIDE")
				.then(function() { $state.go('index.companies')});
			})				
		}

	} 
	
	vm.remove = function(item) {
		gmDialog.prompt(item, "STERGERE", "Sunteti ABSOLUT sigur?","DA", "NU")
		.then(function(r) {
			if ( typeof r !== "undefined" && r.toLowerCase() == "da" ) {
				var promise = [];
				
				promise.push(qs.remove('companies', {id: item.id}));
				promise.push(qs.smartRemove('departments', 'company', item.id));
				angular.forEach(vm.users, function(e,i) {
					var uid = e.id;
					promise.push(qs.smartRemove('users', 'id', uid));
					promise.push(qs.smartRemove('userData', 'uid', uid));
					promise.push(qs.smartRemove('subscriptions', 'uid', uid));
				})
				
				
				$q.all(promise).then(function() { 
					gmDialog.alert("STERGERE", "Stergerea a fost efectuată cu succes!", "ÎNCHIDE!")
					.then(function(){ $state.go('index.companies'); })
				})
			}
		})

	}
   
  
  }
    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.companies', {
            url: '/companies',
            views: {
                'content@index': {
                    templateUrl: "app/states/companies/main.tpl",
                    controller: 'CompaniesController',
                    controllerAs: 'vm',
                    resolve: {
                        companies: function(qs) {
                             return qs.get('companies')
                            .then(function(response){
                                return response.data.result;
                            })
                             
                        },
						counties: function ( countryService) {
							return countryService.counties().then(function(r) { return r.data.result; })
						}
                    }
               
                }
            }
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('CompaniesController', CompaniesController);

  /** @ngInject */
  function CompaniesController( companies, counties, qs, gmDialog, $mdDialog  ) {
      var vm = this;

	angular.forEach(companies, function(e,i) {
		companies[i].county = counties.filter(function(item) { return item.id == e.county; })[0];
		qs.get('localitati', {key:'id', value: e.city})
		.then( function(r) { companies[i].city = r.data.result[0];})
	})
    vm.companies = companies;


   
  
  }
    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider) {

        $stateProvider
        .state('index.apps', {
            url: '/apps',
            views: {
                'content@index': {
                    templateUrl: "app/states/apps/main.html",
                    controller: 'AppsController',
                    controllerAs: 'vm',
                    resolve: {
                        apps: function(qs) {
                             return qs.get('apps')
                            .then(function(response){
                                return response.data.result;
                            })
                             
                        }
                    }
               
                }
            }
            
        })
        
    }

})();
(function() {
  'use strict';

  angular
    .module('app')
    .controller('AppsController', AppsController);

  /** @ngInject */  
  function AppsController( apps, qs, gmDialog, $mdDialog, $mdSidenav, $window, $q ) {
      var vm = this;

      vm.apps = apps;

      vm.confirm = function(item) {
          qs.update('apps', item)
            .then(function(r) {
              gmDialog.alert("SUCCES!", "Ati actualizat cu succes aplicatia "+item.appName, "ÎNCHIDE" )
          })
      }
    
      vm.action = function(action, item) {
          var modal = $mdDialog.show({
              controller: "AppModalController",
              controllerAs: "vm",
              templateUrl: "app/states/apps/AppModalTemplate.html",
              clickOutsideToClose: true,
			  locals: { action: action, item: item }
          });
	  
	  
		  modal.then(function(r){
			  
			  if ( r.action == "create") {
				  qs.create('apps', r.data)
				  .then(function(resp) {
					  
					  r.data.id = resp.data.msg.toString();
					  gmDialog.alert("SUCCES!", "Aplicația a fost creată!", "ÎNCHIDE")
					  .then( function(){
						  vm.apps.push(r.data);
					  })
				  })
			  }
			  if ( r.action == "update") {
				  qs.update('apps', r.data)
				  .then(function(resp) {
					  gmDialog.alert("SUCCES!", "Aplicația a fost actualizata!", "ÎNCHIDE");
				  })
			  }	
			  if ( r.action == "remove") {
				  var promise = [];
				  
				  promise.push(qs.remove('apps', {id:r.data.id}));
				  promise.push(qs.smartRemove('subscriptions', 'appId', r.data.id));
				  
				  $q.all(promise).then(function(resp) {
					  gmDialog.alert("SUCCES!", "Aplicația și abonamentele aferente au fost șterse!", "ÎNCHIDE")
					  .then(function(r) {
						  vm.apps.splice(vm.apps.indexOf(r.data),1);
					  })
				  })
			  }				  
		  })
	  }
	  
  
   
  
  }
    

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('AppModalController', AppModalController);

  /** @ngInject */  
  function AppModalController( qs, $mdDialog, item ) {
      var vm = this;

	  vm.item = item;

      
      vm.action = function(action, data) {
 			console.log(action,data);
		  
		  $mdDialog.hide({action:action, data:data});
      }
  
  }
    

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController(APP,localStorageService, $state, $mdBottomSheet, $mdSidenav, gmDialog,  $log, menuService, $window, $mdDialog, mainMenuService, qs, $q ) {
      var vm = this;
	  
	  vm.frontPage = mainMenuService.items();

      //data
    console.log("apikey", localStorageService.get('apikey'));
     if ( localStorageService.get('apikey') == null ) { $state.go('login'); }

    
/*	  if ( localStorageService.get('uid') == "78") {
		  
		  var x = $mdDialog.show({
			  template: "<md-card layout-padding>Draga Laczi,<br>Imi cer scuze, nu mi-am dat seama ca erai in aplicatie<br> si ti-am bulit pe la semnaturi ceva...<br>Nu e vina programului e vina mea :) <md-button class = 'md-raised' ng-click = 'vm.close()'>inchide acest mesaj</md-button></md-card>",
			  controller: function($mdDialog) { this.close = function() { $mdDialog.hide();}},
			  controllerAs: "vm"
		  })
	  }*/
      
      //define menu on leftnav
      
      vm.title = APP.name;
      vm.version = APP.version;
      vm.appName = APP.name;
      vm.appVersion = APP.version;
      vm.menu = menuService.left();
      
      // Toolbar search toggle
      vm.toggleSearch = function() {
        vm.showSearch = !vm.showSearch;
      };

      // Sidenav toggle
      vm.toggleSidenav = function(menuId) {
          // fix for overlapping on larger page (gabizz)
          var pageWidth = angular.element($window).width();
         
//          if (pageWidth < 1200 ) {
               $mdSidenav(menuId).toggle();
		  		vm.toggled = !vm.toggled
//          }
       
      };
      
      // Bottomsheet & Modal Dialogs
      vm.alert = '';
      vm.showListBottomSheet = function($event) {
        vm.alert = '';
        $mdBottomSheet.show({
          templateUrl: 'app/states/_main/listBottomSheet.template.html',
          controller: 'ListBottomSheetController',
          controllerAs: 'libo',
          targetEvent: $event
        });
      };
	  
	  //statistics
	  
	  //COMPANIES COUNT
	  vm.stats = {};
	 
	  vm.count = {};
	  vm.count.subs = {};
	  
	  var q1 = qs.get('companies').then(function(r) { return  r.data; })
	  var q2 = qs.get('users').then(function(r) { return  r.data; })
	  var q3 = qs.get('subscriptions').then(function(r) { return  r.data; })
	  var q4 = qs.get('apps').then(function(r) { return  r.data; })
	  var q5 = qs.get('roles').then(function(r) { return  r.data; })

	  $q.all([q1, q2, q3, q4, q5]).then(function (r) {

	  	var companies = r[0],
	  		users = r[1],
	  		subs = r[2],
	  		apps = r[3],
	  		roles = r[4];

	  	// get expired subscriptions
	  	var inAMonth = moment().add(1, 'month').unix();
		var today = moment().unix();
	  	var toExpire = [];
		var expired = [];
		var active = [];
	  	var exp, sub;

	  	var subs = subs.result;

	  	vm.subs = {};
		  vm.subs.all = subs;
		  

	  	angular.forEach(subs, function (e, i) {
	  		sub = e.endDate;
			console.log( sub, today, inAMonth);
			if ( sub > today ) { active.push(e); }
	  		if ((  sub > today ) && (  sub < inAMonth ) ) {
	  			toExpire.push(e);
	  		} else if ( sub < today ) {
				expired.push(e);
			}
			vm.subs.active 		= active;
			vm.subs.toExpire 	= toExpire;
			vm.subs.expired 	= expired;
	  	})
		  
		 //get counts
		  
		  vm.users = users.result;
		  vm.companies = companies.result;

	  })

	  }

})();

(function() {
  'use strict';

  angular
    .module('app')
    .controller('ListBottomSheetController', ListBottomSheetController);

  /** @ngInject */
  function ListBottomSheetController($mdBottomSheet, $state) {
      var vm = this;
      

      vm.items = [

        { name: 'Setări aplicație', icon: 'action:ic_settings_24px', state: 'index.settings' },
        { name: 'IEȘIRE', icon: 'action:ic_power_settings_new_24px', state: 'logout' }

      ];

      vm.itemClick = function($index) {
        var clickedItem = vm.items[$index];
        $mdBottomSheet.hide(clickedItem);
        $state.go(clickedItem.state);
      };
  }
  
    

    

})();

(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {

        $stateProvider
            .state('index', {
                abstract: true,
                views: {
                    '@': {
                        templateUrl: 'app/states/_main/main.html',
                        controller: 'MainController',
                        controllerAs: 'vm'
                    },
                    'navleft@index': {
                        templateUrl: 'app/states/_main/partials/navleft.html'
                    },
					'top@index': {
						templateUrl: 'app/states/_main/partials/top.html'
					},
					'topMDSM@index': {
						templateUrl: 'app/states/_main/partials/topMD-SM.html'
					},					
                    'toolbars@index': {
                        templateUrl: 'app/states/_main/partials/toolbars.html'
                    },
                    'content@index': {
                        templateUrl: 'app/states/_main/partials/content.html'
                    }                   

                }

            })
        .state('index.main', {
                url: '/'
            });

        $urlRouterProvider.otherwise('/');
    }

})();
(function() {
  'use strict';

  angular
      .module('app')
      .service('userService', userService);

  /** @ngInject */
  function userService( APP, $http) {

    this.getCurrentUser = getCurrentUser;
    this.getUser        = getUser;
    this.getUsers       = getUsers;
    this.create         = create;
    this.update         = update;
    this.remove         = remove;

    function getUsers() {
        
      var resp = $http.post(API +'users/', '' ) 
      .then(function(response) {
          return response;
      });
        return resp;
    }

    function getCurrentUser() {
        var resp = $http.post( APP.api+'users/getUser', '').then( function(r) { return r; } );
        return resp;        
    }

    function getUser(data) {
        var resp = $http.post( APP.api+'users/getUser', {id:data}).then( function(r) { return r; } );
        return resp;        
    }
      
    function create(data) {
        var resp = $http.post( APP.api+'users/create', data).then( function(r) { return r; } );
        return resp;
    }

   function update(data) {
       var resp = $http.post( APP.api+ 'users/update', data).then( function(r) { return r;} );
       return resp;
   }
      
   function remove(data) {
       var resp = $http.post( APP.api+'users/delete', {'id':data}).then( function(r) { return r;} );
       return resp;
   }      
      
  }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('tipDoc', tipDoc);

    /** @ngInject */
    function tipDoc() {



        this.get = get;

        function get() {
            return [{
                    id: 1,
                    name: "Cerere afişarea ofertă de vânzare",
                    include: "app/states/dosar/includes/cerere.tpl",
                    object: "cerere"
          },
                {
                    id: 2,
                    name: "1B - Ofertă de vânzare teren",
                    include: "app/states/dosar/includes/oferta.tpl",
                    object: "oferta"
          },
                {
                    id: 3,
                    name: "PV1- afişare a ofertei de vânzare",
                    include: "app/states/dosar/includes/pv1.tpl",
                    object: "pvAfisareCerere"
          },
                {
                    id: 4,
                    name: "1C - Lista preemptorilor",
                    include: "app/states/dosar/includes/listaPre.tpl",
                    object: "listaPreemptori"
          },
                {
                    id: 5,
                    name: "PV2 - afişare a listei preemptorilor",
                    include: "app/states/dosar/includes/pv2.tpl",
                    object: "pvAfisareListaPreemptori"
          },
                {
                    id: 6,
                    name: "Solicitare vânzător - necesitate 3A",
                    include: "app/states/dosar/includes/necesar3A.tpl"
          },
                {
                    id: 7,
                    name: "3A - Adresă Direcţia de Cultură",
                    include: "app/states/dosar/includes/3A.tpl"
          },
                {
                    id: 8,
                    name: "3B - Cerere eliberare aviz specific",
                    include: "app/states/dosar/includes/3B.tpl"
          },
                {
                    id: 9,
                    name: "2D - Cerere aviz M.Ap.N.",
                    include: "app/states/dosar/includes/2D.tpl"
          },
                {
                    id: 10,
                    name: "1D - Comunicări de acceptare",
                    include: "app/states/dosar/includes/1D.tpl"
          },

                {
                    id: 12,
                    name: "Alegere prmpt. potenţial cumpărător",
                    include: "app/states/dosar/includes/ppc.tpl"
          },
                {
                    id: 13,
                    name: "Adresă înaintare / Direcţia Agricolă",
                    include: "app/states/dosar/includes/adresaDirAgr.tpl"
          },
                {
                    id: 14,
                    name: "PV4 - final (cu preemptori) ",
                    include: "app/states/dosar/includes/pv4cu.tpl"
          },
                {
                    id: 15,
                    name: "PV4 - final (fără preemptori) ",
                    include: "app/states/dosar/includes/pv4fara.tpl"
          },
                {
                    id: 16,
                    name: "1E - Adeverință pentru vânzare liberă ",
                    include: "app/states/dosar/includes/1E.tpl"
          },
       ];
        }

    }

})();
(function() {
  'use strict';

  angular
      .module('app')
      .service('menuService', menuService);

  /** @ngInject */
  function menuService() {

    
      
    this.left = left;

      function left() {
            return [
              {
                  id  : 1,
                  name: 'Registru',
                  icon: 'action:ic_home_24px',
                  state: 'index.registru',
          
              },
              {
                  id  : 2,
                  name: 'Titulari',
                  icon: 'action:ic_home_24px',
                  state: 'index.titulari',
                  
              },                
              {
                  id  : 3,
                  name: 'Rapoarte',
                  icon: 'action:ic_home_24px',
                  state: 'index.companies',
                
              },
              {
                  id  : 4,
                  name: 'Configurări',
                  icon: 'action:ic_settings_24px',
                  state: 'index.settings'
              },
              
            ];
      } 
   
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('qs', qs);

  /** @ngInject */
  function qs(	APP, $http) {

    this.get            =  get;
    this.create         = create;
    this.update         = update;
    this.remove         = remove;
    this.smartRemove    = smartRemove;


    function get(table, data) {
        
        var postdata = {};
        postdata.scope = table;
        postdata.where= [];
        postdata.where.push(data);
       // $log.info("postdata api/get:",JSON.stringify(postdata));
        var resp = $http.post(APP.api  + 'api/get', postdata ) 
            .then(function(response) { return response; });
        return resp;
    }      
 
    function create(table, req) {
        var postdata = {};
        postdata.scope = table;
        postdata.data = req;
        var resp = $http.post(APP.api  + 'api/create', postdata ) 
            .then(function(response) { return response; });
        return resp;
    }   
 
    function update(table, data) {
        var postdata = {};
        postdata.scope = table;
        postdata.data = {};
        postdata.data = data;
        var resp = $http.post(APP.api  + 'api/update', postdata ) 
            .then(function(response) { return response; });
        return resp;
    }  

    function remove(table, data) {
        var postdata = {};
        postdata.scope = table;
        postdata.data = data;
        var resp = $http.post(APP.api  + 'api/delete', postdata ) 
            .then(function(response) { return response; });
        return resp;
    }    
	  
    function smartRemove(table, key, value) {
        var postdata = {};
        postdata.scope = table;
        postdata.where = {key:key, value:value};
        return $http.post(APP.api  + 'api/smartdelete', postdata ) 
            .then(function(response) { return response; });
        
    } 	  
  }

})();
(function() {
  'use strict';

  angular
      .module('app')
      .service('mainMenuService', mainMenuService);

  /** @ngInject */
  function mainMenuService() {

    
      
    this.items = items;

      function items() {
            return [
              {
                  index  : 0,
                  name: 'ROLURI',
                  icon: 'id-card',
                  state: 'index.roles',
				  bgColor: 'DarkBlue',
				  textColor: 'white'
              },				
              {
                  index  : 1,
                  name: 'APLICAȚII',
                  icon: 'file-code-o',
                  state: 'index.apps',
				  bgColor: 'DarkBlue',
				  textColor: 'white'
              },				
              {
                  index  : 2,
                  name: 'COMPANII',
                  icon: 'line-chart',
                  state: 'index.companies',
				  bgColor: 'DarkBlue',
				  textColor: 'white'
              },
              {
                  index  : 3,
                  name: 'UTILIZATORI',
                  icon: 'users',
                  state: 'index.users',
				  bgColor: 'DarkBlue',
				  textColor: 'white'
              },
				

              {
                  index  : 4,
                  name: 'ABONAMENTE',
                  icon: 'money',
                  state: 'index.subscriptions',
				  bgColor: 'DarkBlue',
				  textColor: 'white'
			  }				
              
            ];
      } 
   
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('isValid', isValid);

  /** @ngInject */
  function isValid() {

    
      
    this.cnp = cnp;


	// cnp validation
    function cnp(p_cnp) {
        var result = {};
        var i = 0,
            year = 0,
            hashResult = 0,
            cnp = [],
            hashTable = [2, 7, 9, 1, 4, 6, 3, 5, 8, 2, 7, 9];
        if (p_cnp.length !== 13) {
            result.ok = false;
            result.err = "Lungime incorectă";
            return result;
        }
        for (i = 0; i < 13; i++) {
            cnp[i] = parseInt(p_cnp.charAt(i), 10);
            if (isNaN(cnp[i])) {
                
                result.ok = false;
                result.err = "CNP trebuie să fie numeric!";
                return result;
            }
            if (i < 12) {
                hashResult = hashResult + (cnp[i] * hashTable[i]);
            }
        }
        hashResult = hashResult % 11;
        if (hashResult === 10) {
            hashResult = 1;
        }
        year = (cnp[1] * 10) + cnp[2];
        switch (cnp[0]) {
        case 1:
        case 2:
            {
                year += 1900;
            }
            break;
        case 3:
        case 4:
            {
                year += 1800;
            }
            break;
        case 5:
        case 6:
            {
                year += 2000;
            }
            break;
        case 7:
        case 8:
        case 9:
            {
                year += 2000;
                if (year > (parseInt(new Date().getYear(), 10) - 14)) {
                    year -= 100;
                }
            }
            break;
        default:
            {
                return false;
            }
        }
        if (year < 1800 || year > 2099) {
            return false;
        }
        return (cnp[12] === hashResult);

    }
    
          
  }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .service('httpMessage', httpMessage);

    /** @ngInject */
    function httpMessage() {

        this.get = getMessage;

        var messages = [
            {
                "id": 1,
                "code": 200,
                "short": "OK",
                "long": "The request is OK (this is the standard response for successful HTTP requests)"},
            {
                "id": 2,
                "code": 201,
                "short": "Created",
                "long": "The request has been fulfilled, and a new resource is created"},
            {
                "id": 3,
                "code": 202,
                "short": "Accepted",
                "long": "The request has been accepted for processing, but the processing has not been completed"},
            {
                "id": 4,
                "code": 203,
                "short": "Non-Authoritative Information",
                "long": "The request has been successfully processed, but is returning information that may be from another source" },
            {
                "id": 5,
                "code": 204,
                "short": "No Content",
                "long": "The request has been successfully processed, but is not returning any content"},
            {
                "id": 6,
                "code": 205,
                "short": "Reset Content",
                "long": "The request has been successfully processed, but is not returning any content, and requires that the requester reset the document view" },
            {
                "id": 7,
                "code": 206,
                "short": "Partial Content",
                "long": "The server is delivering only part of the resource due to a range header sent by the client" },
            {
                "id": 8,
                "code": 300,
                "short": "Multiple Choices",
                "long": "A link list. The user can select a link and go to that location. Maximum five addresses �" },
            {
                "id": 9,
                "code": 301,
                "short": "Moved Permanently",
                "long": "The requested page has moved to a new URL�" },
            {
                "id": 10,
                "code": 302,
                "short": "Found",
                "long": "The requested page has moved temporarily to a new URL�" },
            {
                "id": 11,
                "code": 303,
                "short": "See Other",
                "long": "The requested page can be found under a different URL" },
            {
                "id": 12,
                "code": 304,
                "short": "Not Modified",
                "long": "Indicates the requested page has not been modified since last requested" },
            {
                "id": 13,
                "code": 306,
                "short": "Switch Proxy",
                "long": "No longer used" },
            {
                "id": 14,
                "code": 307,
                "short": "Temporary Redirect",
                "long": "The requested page has moved temporarily to a new URL" },
            {
                "id": 15,
                "code": 308,
                "short": "Resume Incomplete",
                "long": "Used in the resumable requests proposal to resume aborted PUT or POST requests" },
            {
                "id": 16,
                "code": 400,
                "short": "Bad Request",
                "long": "The request cannot be fulfilled due to bad syntax" },
            {
                "id": 17,
                "code": 401,
                "short": "Unauthorized",
                "long": "The request was a legal request, but the server is refusing to respond to it. For use when authentication is possible but has failed or not yet been provided" },
            {
                "id": 18,
                "code": 402,
                "short": "Payment Required",
                "long": "Reserved for future use" },
            {
                "id": 19,
                "code": 403,
                "short": "Forbidden",
                "long": "The request was a legal request, but the server is refusing to respond to it" },
            {
                "id": 20,
                "code": 404,
                "short": "Not Found",
                "long": "The requested page could not be found but may be available again in the future" },
            {
                "id": 21,
                "code": 405,
                "short": "Method Not Allowed",
                "long": "A request was made of a page using a request method not supported by that page" },
            {
                "id": 22,
                "code": 406,
                "short": "Not Acceptable",
                "long": "The server can only generate a response that is not accepted by the client" },
            {
                "id": 23,
                "code": 407,
                "short": "Proxy Authentication Required",
                "long": "The client must first authenticate itself with the proxy" },
            {
                "id": 24,
                "code": 408,
                "short": "Request Timeout",
                "long": "The server timed out waiting for the request" },
            {
                "id": 25,
                "code": 409,
                "short": "Conflict",
                "long": "The request could not be completed because of a conflict in the request" },
            {
                "id": 26,
                "code": 410,
                "short": "Gone",
                "long": "The requested page is no longer available" },
            {
                "id": 27,
                "code": 411,
                "short": "Length Required",
                "long": "The \"Content-Length\" is not defined. The server will not accept the request without it�" },
            {
                "id": 28,
                "code": 412,
                "short": "Precondition Failed",
                "long": "The precondition given in the request evaluated to false by the server" },
            {
                "id": 29,
                "code": 413,
                "short": "Request Entity Too Large",
                "long": "The server will not accept the request, because the request entity is too large" },
            {
                "id": 30,
                "code": 414,
                "short": "Request-URI Too Long",
                "long": "The server will not accept the request, because the URL is too long. Occurs when you convert a POST request to a GET request with a long query information�" },
            {
                "id": 31,
                "code": 415,
                "short": "Unsupported Media Type",
                "long": "The server will not accept the request, because the media type is not supported�" },
            {
                "id": 32,
                "code": 416,
                "short": "Requested Range Not Satisfiable",
                "long": "The client has asked for a portion of the file, but the server cannot supply that portion" },
            {
                "id": 33,
                "code": 417,
                "short": "Expectation Failed",
                "long": "The server cannot meet the requirements of the Expect request-header field" },
            {
                "id": 34,
                "code": 500,
                "short": "Internal Server Error",
                "long": "A generic error message, given when no more specific message is suitable" },
            {
                "id": 35,
                "code": 501,
                "short": "Not Implemented",
                "long": "The server either does not recognize the request method, or it lacks the ability to fulfill the request" },
            {
                "id": 36,
                "code": 502,
                "short": "Bad Gateway",
                "long": "The server was acting as a gateway or proxy and received an invalid response from the upstream server" },
            {
                "id": 37,
                "code": 503,
                "short": "Service Unavailable",
                "long": "The server is currently unavailable (overloaded or down)" },
            {
                "id": 38,
                "code": 504,
                "short": "Gateway Timeout",
                "long": "The server was acting as a gateway or proxy and did not receive a timely response from the upstream server" },
            {
                "id": 39,
                "code": 505,
                "short": "HTTP Version Not Supported",
                "long": "The server does not support the HTTP protocol version used in the request" },
            {
                "id": 40,
                "code": 511,
                "short": "Network Authentication Required",
                "long": "The client needs to authenticate to gain network access" }];

        function getMessage(id) {
            if (typeof id == 'undefined') { return messages; } 
            return messages.filter(function(item) { return item.code == id; })
        }        



    }

})();
 (function() {
  'use strict';

  angular
      .module('app')
      .service('gmDialog', gmDialog);

  /** @ngInject */
  function gmDialog($mdDialog) {

    this.alert            =  alert;
    this.confirm          =  confirm;
    this.prompt          =   prompt;



    function alert(titleText, messageText, closeButtonText) {
        
        var title = titleText || null, 
            contents = messageText || null,
            close = closeButtonText || null;
        
        var alert = $mdDialog.show(
            $mdDialog.alert()
                .parent(angular.element(document.querySelector('#popupContainer')))
                .clickOutsideToClose(true)
                .title(title)
                .textContent(contents)
                .ariaLabel('Confirm')
                .ok(close)
             

        );
        return alert;
    }  
      
    function confirm(ev, titleText, messageText, optin, optout) {
        var title = titleText || null,
            contents = messageText || null,
            yesButton = optin || "OK",
            noButton = optout || "CANCEL";
        
        var confirm = $mdDialog.confirm()
              .title(title)
              .textContent(contents)
              .ariaLabel('confirm')
              .targetEvent(ev)
              .ok(yesButton)
              .cancel(noButton);

        var show = $mdDialog.show(confirm);
        return show;
    }

      function prompt(ev, title, textContext, yesButton, noButton) {
          title = title || null;
          textContext = textContext || null;
          yesButton = yesButton || "OK";
          noButton = noButton || "CANCEL";

          // Appending dialog to document.body to cover sidenav in docs app
          var confirm = $mdDialog.prompt()
              .title(title)
              .textContent(textContext)
              .ariaLabel('prompt')
              .targetEvent(ev)
              .ok(yesButton)
              .cancel(noButton);

          var modal = $mdDialog.show(confirm);
          return modal;

      }
      
    
  }

})();


 
 (function() {
  'use strict';

  angular
      .module('app')
      .service('fileService', fileService);

  /** @ngInject */
  function fileService() {

    this.getFile            =  getFile;
    this.upload             =  upload;
    this.remove             =  remove;



    function getFile(fileName) {
        
        return fileName;
    }  
      
    function upload(file) {
        return file; 
    }
      
    function remove(file) {
        return file;
    }
  }

})();


 
(function() {
  'use strict';

  angular
      .module('app')
      .service('exportService', exportService);
    
    function exportService($timeout) {
  
        this.print     = print;
       

        function print(data) {
            var popupWindow = window.open('', '_blank', 'width=1000,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
            popupWindow.document.open();
            popupWindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="assets/css/print.style.css" /></head><body onload="window.print()">' + data + '</html>');
            $timeout(function() {
                popupWindow.document.close();  
                popupWindow.window.close();
            }, 500);
                      
          return null;
        }           
            
    }


})();
(function() {
  'use strict';

  angular
      .module('app')
      .service('dateService', dateService);

  /** @ngInject */
  function dateService() {
	  
		this.convertEN  = convertEN;

		function pad(s) { return (s < 10) ? '0' + s : s; }
		
		function convertEN(item) {
			var d = new Date(item);
			return [d.getFullYear(),  pad(d.getMonth()+1), pad(d.getDate())].join('-');
		}		

	}

})();
(function() {
  'use strict';

  angular
      .module('app')
      .service('countryService', countryService);

  /** @ngInject */
  function countryService(APP, $http, $q) {

    
      
    this.counties = counties;
    this.countyById = countyById;
    this.countyByName = countyByName;
    this.city = city;
      
    this.cityById = cityById;
    this.citiesByCountyId = citiesByCountyId;

    function counties() {
        var postdata = {};
        postdata.scope = 'judete';
        postdata.where = [];
        
      return  $http.post(APP.api +'/api/get', postdata ) 
      .then(function(response) {
          return response;
      });

    }
    
    function countyById(id) {
        var postdata = {};
        postdata.scope = 'judete';
        postdata.where = [];
        postdata.where.push({'key':'id', 'value':id});
        var resp = $http.post(APP.api +'/api/get', postdata ) 
        .then(function(response) {
            return response;
        });
            return resp;
    }
      
    function countyByName(name) {
        var postdata = {};
        postdata.scope = 'judete';
        postdata.where = [];
        postdata.where.push({'key':'name', 'value':name});
        var resp = $http.post(APP.api +'/api/get', postdata ) 
        .then(function(response) {
            return response;
        });
            return resp;
    } 
      
      
    function cityById(id) {
        var postdata = {};
        postdata.scope = 'localitati';
        postdata.where = [];
        postdata.where.push({'key':'id', 'value':id});
        var resp = $http.post(APP.api +'/api/get', postdata ) 
        .then(function(response) {
            return response;
        });
            return resp;
    } 
      
    function citiesByCountyId(countyId) {
        var postdata = {};
        postdata.scope = 'localitati';
        postdata.where= [];
        postdata.where.push({'key':'county_id','value':countyId});
        return  $http.post(APP.api +'/api/get', postdata ) 
        .then(function(r) {
            return r;
        });

    } 
      
    function city(cityId) {
        var localitate,localitati, judete, promise;
        
        localitate = cityById(cityId).then(function(r) { return r.data.result[0]; });
         
        localitati = $q.when(localitate).then(function(r) {
            return citiesByCountyId(r.county_id).then(function(rs) {return rs.data.result;});
        })
  
        judete = counties().then(function(r) {   return r.data.result; });
        
        promise = [localitate, localitati, judete];
        return $q.all(promise);
    }
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('convert', convert);
    
    function convert() {
  
        this.arr2tree     = arr2tree;
       

        function arr2tree(data, options) {
          options = options || {};
          var ID_KEY = options.idKey || 'id';
          var PARENT_KEY = options.parentKey || 'parent';
          var CHILDREN_KEY = options.childrenKey || 'children';

          var item, id, parentId;
          var map = {};
            for(var i = 0; i < data.length; i++ ) { // make cache
            if(data[i][ID_KEY]){
              map[data[i][ID_KEY]] = data[i];
              data[i][CHILDREN_KEY] = [];
            }
          }
          for (var i = 0; i < data.length; i++) {
            if(data[i][PARENT_KEY]) { // is a child
              if(map[data[i][PARENT_KEY]]) // for dirty data
              {
                map[data[i][PARENT_KEY]][CHILDREN_KEY].push(data[i]); // add child to parent
                data.splice( i, 1 ); // remove from root
                i--; // iterator correction
              } else {
                data[i][PARENT_KEY] = 0; // clean dirty data
              }
            }
          };
          return data;
        }           
            
    }



})();
(function() {
  'use strict';

  angular
      .module('app')
      .service('authService', authService);

  /** @ngInject */
  function authService(APP, $http) {

    this.login = login;
    this.logout = logout;


    function login(data) {
        data.app = APP.app;
        return $http.post(APP.api+'login', data ) 
        .then(function(response) {
          return response.data;
        });
    }




   function logout() {
       var data = {};
       data.app = APP.app;
       return $http.post( APP.api + 'logout', data).then( function(r) { return r;});
   } 
  }

})();

(function() {
  'use strict';

  angular
      .module('app')
      .service('arrays', arrays);

  /** @ngInject */
  function arrays() {

    this.max = max;
    this.min = min;
    this.closest = closest;

    function max(arr, elem) {
        var item = {};
        item[elem] = 0;
        for ( var i = 0; i < arr.length; i++ ) {
            var e = arr[i];
            if ( parseFloat(e[elem]) > item[elem] ) { item = e; }
        } 
        return item;
    }

    function min(arr, elem) {
        var item = arr[0];
        for ( var i = 0; i < arr.length; i++ ) {
            var e = arr[i];
            if ( e[elem] < item[elem] ) { item = e; }
        } 
        return item;
    }
      
    function closest(arr, attr, value, direction) {
       //our target item
        
        value = parseInt(value);
        var selectItem = arr.filter(function(e) { return e[attr] == value; })[0];
        var selectItemValue = parseInt( selectItem[attr] );
        var ecart = 0;
        
        if (direction == 'before') {
            arr = arr.filter(function(e) { return parseInt(e[attr]) < value; });
        } 
        else if ( direction == 'after' ) {
             arr = arr.filter(function(e) { return parseInt(e[attr]) > value; });
        }
            for ( var i = 0; i< arr.length; i++ ) {

                var test = arr[i];
                var testValue = parseInt( test[attr] );
                var newEcart = Math.abs(selectItemValue - testValue);
                if ( ecart == 0 || newEcart < ecart ) {
                    selectItem = test;
                    ecart = newEcart;
                  
                }
            }
            return selectItem;
        
        
    }      
  }

})();

(function (angular) {
    'use strict';
    function wordDirective() {
        var printSection = document.getElementById('printSection');
        // if there is no printing section, create one
        if (!printSection) {
            printSection = document.createElement('div');
            printSection.id = 'printSection';
            document.body.appendChild(printSection);
        }
        function link(scope, element, attrs) {
            element.on('click', function () {
                var elemToPrint = document.getElementById(attrs.exportElementId);
                if (elemToPrint) {
                    wordExport(elemToPrint);
                }
            });
            window.onafterprint = function () {
                // clean the print section before adding new content
                printSection.innerHTML = '';
            }
        }
        function wordExport(elem) {
            // clones the element you want to print
            
            console.log(angular.element(elem));
            angular.element(elem).wordExport();
        }
        return {
            link: link,
            restrict: 'A'
        };
    }
    angular.module('app').directive('ngWord', [wordDirective]);
}(window.angular));


//word export function
if (typeof jQuery !== "undefined" && typeof saveAs !== "undefined") {
    (function($) {
        $.fn.wordExport = function(fileName) {
            fileName = typeof fileName !== 'undefined' ? fileName : "jQuery-Word-Export";
            var static = {
                mhtml: {
                    top: "Mime-Version: 1.0\nContent-Base: " + location.href + "\nContent-Type: Multipart/related; boundary=\"NEXT.ITEM-BOUNDARY\";type=\"text/html\"\n\n--NEXT.ITEM-BOUNDARY\nContent-Type: text/html; charset=\"utf-8\"\nContent-Location: " + location.href + "\n\n<!DOCTYPE html>\n<html>\n_html_</html>",
                    head: "<head>\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n<style>\n_styles_\n</style>\n</head>\n",
                    body: "<body>_body_</body>"
                }
            };
            var options = {
                maxWidth: 624
            };
            // Clone selected element before manipulating it
            var markup = $(this).clone();

            // Remove hidden elements from the output
            markup.each(function() {
                var self = $(this);
                if (self.is(':hidden'))
                    self.remove();
            });

            // Embed all images using Data URLs
            var images = Array();
            var img = markup.find('img');
            for (var i = 0; i < img.length; i++) {
                // Calculate dimensions of output image
                var w = Math.min(img[i].width, options.maxWidth);
                var h = img[i].height * (w / img[i].width);
                // Create canvas for converting image to data URL
                var canvas = document.createElement("CANVAS");
                canvas.width = w;
                canvas.height = h;
                // Draw image to canvas
                var context = canvas.getContext('2d');
                context.drawImage(img[i], 0, 0, w, h);
                // Get data URL encoding of image
                var uri = canvas.toDataURL("image/png");
                $(img[i]).attr("src", img[i].src);
                img[i].width = w;
                img[i].height = h;
                // Save encoded image to array
                images[i] = {
                    type: uri.substring(uri.indexOf(":") + 1, uri.indexOf(";")),
                    encoding: uri.substring(uri.indexOf(";") + 1, uri.indexOf(",")),
                    location: $(img[i]).attr("src"),
                    data: uri.substring(uri.indexOf(",") + 1)
                };
            }

            // Prepare bottom of mhtml file with image data
            var mhtmlBottom = "\n";
            for (var i = 0; i < images.length; i++) {
                mhtmlBottom += "--NEXT.ITEM-BOUNDARY\n";
                mhtmlBottom += "Content-Location: " + images[i].location + "\n";
                mhtmlBottom += "Content-Type: " + images[i].type + "\n";
                mhtmlBottom += "Content-Transfer-Encoding: " + images[i].encoding + "\n\n";
                mhtmlBottom += images[i].data + "\n\n";
            }
            mhtmlBottom += "--NEXT.ITEM-BOUNDARY--";

            //TODO: load css from included stylesheet
            var styles = "";

            // Aggregate parts of the file together
            var fileContent = static.mhtml.top.replace("_html_", static.mhtml.head.replace("_styles_", styles) + static.mhtml.body.replace("_body_", markup.html())) + mhtmlBottom;

            // Create a Blob with the file contents
            var blob = new Blob([fileContent], {
                type: "application/msword;charset=utf-8"
            });
            saveAs(blob, fileName + ".doc");
        };
    })(jQuery);
} else {
    if (typeof jQuery === "undefined") {
        console.error("jQuery Word Export: missing dependency (jQuery)");
    }
    if (typeof saveAs === "undefined") {
        console.error("jQuery Word Export: missing dependency (FileSaver.js)");
    }
}

(function () {
    'use strict';

    angular
        .module('app')
        .filter('title', title);



    /** @ngInject */

    function title()  {
        return  function(input) {
            var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|de|srl)$/i;
            if ( typeof input !== 'undefined' || input != null ) {
                input = input.toLowerCase();
            } else {
                input = "";
            }
            
            return input.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
                if (index > 0 && index + match.length !== title.length &&
                    match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" &&
                    (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                    title.charAt(index - 1).search(/[^\s-]/) < 0) {
                    return match.toLowerCase();
                }

                if (match.substr(1).search(/[A-Z]|\../) > -1) {
                    return match;
                }

                return match.charAt(0).toUpperCase() + match.substr(1);
            });
        }
    }



})();
(function () {
    'use strict';

    angular
        .module('app')
        .directive('ngRightClick', ngRightClick);



    /** @ngInject */

function ngRightClick($parse) {
    return function(scope, element, attrs) {
        var fn = $parse(attrs.ngRightClick);
        element.bind('contextmenu', function(event) {
            scope.$apply(function() {
                event.preventDefault();
                fn(scope, {$event:event});
            });
        });
    };
};



})();


(function (angular) {
    'use strict';
    function printDirective() {
        var printSection = document.getElementById('printSection');
/*        if (printSection != null) {
            printSection.remove();
        }*/
		console.log(printSection);
        // if there is no printing section, create one

        printSection = document.createElement( 'div' );
        printSection.id = 'printSection';
        document.body.appendChild( printSection );
        

        function link(scope, element, attrs) {
            element.on('click', function () {
                console.log("attrs", attrs);
                var elemToPrint = document.getElementById(attrs.printElementId);
                if (elemToPrint) {
                    printElement(elemToPrint);
                }
            });

        }
        function printElement(elem) {
            // clones the element you want to print
            var domClone = elem.cloneNode(true);
            printSection.appendChild(domClone);
//            console.log(printSection);
            window.print();
            printSection.innerHTML = '';
            
        }
        return {
            link: link,
            restrict: 'A'
        };
    }
    angular.module('app').directive('ngPrint', [printDirective]);
}(window.angular));
(function () {
    'use strict';

    angular
        .module('app')
        .directive('dz', dzDirective)
        .filter('comma2decimal', comma2decimal)
        .filter('decimal2comma', decimal2comma)
        .filter('dz', dz);



    /** @ngInject */
    function dzDirective($filter) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModelController) {

                ngModelController.$parsers.push(function (data) {
                    //convert data from view format to model format
                    data = $filter('comma2decimal')(data);
                    return data;
                });

                ngModelController.$formatters.push(function (data) {
                    //convert data from model format to view format
                    data = $filter('decimal2comma')(data);
                    return data;
                });
            }
        };
    }
    // parser
    function comma2decimal() {

        return function (input) {

            var ret = input ? input.toString().trim().replace(",", ".") : input.toString();
            if (ret.length < 1 || isNaN(ret)) {
                alert('NUMAI NUMERE!');
                return '';
            }
            return parseFloat(ret);
        };
    }

    // formatter
    function decimal2comma() {

        return function (input) {
            if (isNaN(input) || input == null) {
                return null;
            }
            // transform point to comma
            var ret = input ? input.toString().replace(".", ",") : input.toString();
            // deal with non-numbers


            // always show 2 decimals (formatter)
            if (ret) {
                var decArr = ret.split(",");
                if (decArr.length > 1) {
                    var decimals = decArr[1].length;

                    if (decimals === 1) {
                        ret += "0";
                    } // input value or model has 1 decimals
                    if (decimals === 2) {
                        ret += "";
                    } // input value or model has 2 decimals
                } else {
                    ret += ",00"; // input value or model has no decimal
                }
            }

            return ret;
        };
    }

    function dz() {

        return function (input) {

            if (isNaN(input) || input == null || typeof input === 'undefined') {
                return '';
            }
            // transform point to dot
            var r = input ? Math.round(input, 2).toString().replace(".", ",") : input.toString();
            // deal with non-numbers


            // always show 2 decimals (formatter)
            if (r) {
                var decArr = r.split(",");
                if (decArr.length > 1) {
                    var decimals = decArr[1].length;
                    if (decimals === 0) {
                        r += "00"
                    }
                    if (decimals === 1) {
                        r += "0";
                    } // input value or model has 1 decimals
                    if (decimals === 2) {
                        r += "";
                    } // input value or model has 2 decimals
                } else {
                    r += ",00"; // input value or model has no decimal
                }
            }

            return r;
        };
    }



})();
(function () {
    'use strict';

    angular
        .module('app')
        .filter('inLitere', inLitere);



    /** @ngInject */

    function inLitere()  {
        return function(item) {
			return  smarty_modifier_transf(item);
		}
		
		
    }





	function smarty_modifier_transf(item) {
	   var bnr= item.split(",");
	   var cstr="";
	   for ( var i=0; i<bnr.length; i++ ) {
		  item=bnr[i].replace([",","."], "");
		  var sute="", zeci="", uni="";
		  var un = ["miliard ", "miliarde ", "milion ", "milioane ", "mie ", "mii ", "", ""];
		  var sir = "";
		  var s = "1";
		  var num = 4;
		   					
		  while (s != "") {
			 s = item.slice(-3);
			  
			 if (s=="") break;
			 item = (item.length-3>0)?item.slice( 0, item.length-3):"";
			 var ss = "";
			 if (s!="") {
				switch(s, s.length) {
				   case 3:
				      console.log(s.length);
					  sute = s.slice(1, 1);
						console.log("sute:", sute);
					  zeci = s.slice(1, 1);
						console.log('zeci:', zeci);
					  uni = s.slice( 2, 1);
						console.log('unitati:', uni);
					  ss = numar(sute, 1) + ((sute==1)?"suta ":((sute>1)?" sute ":""));
					  if (zeci==1 && uni!=0)
						 ss=ss.numar(uni, 4)+"sprezece "+un[num*2];
					  else if (zeci==1 && uni==0)
						 ss="zece "+un[num*2];
					  else {
						 ss=ss+numar(zeci, 2) + ((zeci!=0)?"zeci ":"") + ((uni!="0") ? "si "+numar(uni,3):"") + ((s!="000")?un[num*2-1]:"");
					  }
					  sir = ss + sir;
					  break;
				   case 2:
					  sute = 0;
					  zeci = s.slice(0, 1);
					  uni = s.slice( 1, 1);
					  if (zeci == 1 && uni != 0)
						 ss = ss + numar(uni, 4) + "sprezece " + un[num*2-1];
					  else if (zeci == 1 && uni == 0)
						 ss = "zece " + un[num * 2];
					  else
						 ss = ss + numar(zeci, 2) + ((zeci!=0)?"zeci ":"") + ((uni!="0")?"si ".numar(uni,3):"") + un[num*2-1];
					  sir = ss + sir;
					  break;
				   case 1:
					  sute = 0;
					  zeci = 0;
					  uni = s.slice(0, 1);
					  sir = numar(uni, (num==3)?1:3) + ((uni==1)?un[(num-1)*2]:un[(num-1)*2+1]) + sir;
					  break;
				}
				num--;
			 }
		  }
		  if (i==0)
			 cstr+=sir+" lei si ";
		  else if (i==1)
			 cstr+=sir+" bani";
	   }
		console.log(cstr);
	   return cstr;
	}
	
	function numar(s, z) {
		var numar;
   switch(z) {
      case 1:
         switch(s) {
            case 1: numar = "o "; break;
            case 2: numar = "doua "; break;
            case 3: numar = "trei "; break;
            case 4: numar = "patru "; break;
            case 5: numar = "cinci "; break;
            case 6: numar = "sase "; break;
            case 7: numar = "sapte "; break;
            case 8: numar = "opt "; break;
            case 9: numar = "noua ";
         }
         break;
      case 2:
         switch(s) {
            case 1: numar = "zece"; break;
            case 2: numar = "doua"; break;
            case 3: numar = "trei"; break;
            case 4: numar = "patru"; break;
            case 5: numar = "cinci"; break;
            case 6: numar = "sai"; break;
            case 7: numar = "sapte"; break;
            case 8: numar = "opt"; break;
            case 9: numar = "noua";
         }
         break;
      case 3:
         switch(s) {
            case 1: numar = "unu "; break;
            case 2: numar = "doi "; break;
            case 3: numar = "trei "; break;
            case 4: numar = "patru "; break;
            case 5: numar = "cinci "; break;
            case 6: numar = "sase "; break;
            case 7: numar = "sapte "; break;
            case 8: numar = "opt "; break;
            case 9: numar = "noua ";
         }
         break;
      case 4:
         switch(s) {
            case 1: numar = "un"; break;
            case 2: numar = "doi"; break;
            case 3: numar = "trei"; break;
            case 4: numar = "pai"; break;
            case 5: numar = "cinci"; break;
            case 6: numar = "sai"; break;
            case 7: numar = "sapte"; break;
            case 8: numar = "opt"; break;
            case 9: numar = "noua";
         }
         break;
   }
   return numar;
}
	
	
	})();
(function () {
	'use strict';

	angular
		.module('app')
		.run(cordovaInit)
		.run(runBlock);

	/** @ngInject */
	function runBlock($log, $rootScope) {

		// $log.debug('runBlock end');
		$rootScope
			.$on('$stateChangeStart',
				function (event, toState, toParams, fromState, fromParams) {
					$("#ui-view").html("");
					$(".page-loading").removeClass("hidden");
				});

		$rootScope
			.$on('$stateChangeSuccess',
				function (event, toState, toParams, fromState, fromParams) {
					$(".page-loading").addClass("hidden");
				});

	}



	function cordovaInit($window, $document, $log) {

		return function (done) {
			if ($window.cordova) {
				$log.info('cordova loaded');
				$document.addEventListener('deviceready', function () {
					done();
				}, false);
			} else {
				$log.info('no cordova env. detected!');
				done();
			}
		}

	}


})();
(function () {
    'use strict';

    angular
        .module('app')
        .config(routerConfig);

    /** @ngInject */
    function routerConfig( $urlRouterProvider) {

        $urlRouterProvider.otherwise('/');
    }

})();
/* global moment:false */
(function() {
  'use strict';

var appData = {
    name: "SIGN PORTAL ADMIN",
    version: "APanel ver. 1.1",
    app: "ADMINPANEL",
    api: "https://auth.de3.undevreau.eu/"
};
    
  angular
    .module('app')
    .constant('APP',  appData)
    .constant('moment', moment);


})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($httpProvider, $logProvider, toastrConfig, $mdThemingProvider, $mdIconProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    toastrConfig.allowHtml = true;
    toastrConfig.timeOut =  0;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;




    $mdThemingProvider
        .theme('default')
        .primaryPalette('indigo')
        .accentPalette('light-blue')
        .warnPalette('red')
        .backgroundPalette('blue-grey');
      

    

/*
 var customGreyMap = $mdThemingProvider.extendPalette('deep-purple', {
    'contrastDefaultColor': 'dark',
    'contrastDarkColors': ['50'],
    '50': 'ffffff'
  });
      
  $mdThemingProvider.definePalette('customBlue', customGreyMap);
  $mdThemingProvider.theme('default')
    .primaryPalette('customBlue', {
      'default': '500',
      'hue-1': '50'
    })
    .accentPalette('customBlue');
  $mdThemingProvider.theme('input', 'default')
        .primaryPalette('grey')
*/




    $mdIconProvider
      // linking to https://github.com/google/material-design-icons/tree/master/sprites/svg-sprite
      // 
      .iconSet('action', 'assets/svg/svg-sprite-action.svg', 24)
      .iconSet('alert', 'assets/svg/svg-sprite-alert.svg', 24)
      .iconSet('av', 'assets/svg/svg-sprite-av.svg', 24)
      .iconSet('communication', 'assets/svg/svg-sprite-communication.svg', 24)
      .iconSet('content', 'assets/svg/svg-sprite-content.svg', 24)
      .iconSet('device', 'assets/svg/svg-sprite-device.svg', 24)
      .iconSet('editor', 'assets/svg/svg-sprite-editor.svg', 24)
      .iconSet('file', 'assets/svg/svg-sprite-file.svg', 24)
      .iconSet('hardware', 'assets/svg/svg-sprite-hardware.svg', 24)
      .iconSet('image', 'assets/svg/svg-sprite-image.svg', 24)
      .iconSet('maps', 'assets/svg/svg-sprite-maps.svg', 24)
      .iconSet('navigation', 'assets/svg/svg-sprite-navigation.svg', 24)
      .iconSet('notification', 'assets/svg/svg-sprite-notification.svg', 24)
      .iconSet('social', 'assets/svg/svg-sprite-social.svg', 24)
      .iconSet('toggle', 'assets/svg/svg-sprite-toggle.svg', 24)
      .iconSet('my', 'assets/svg/_my_collection.svg', 24)
    
      // Illustrated user icons used in the docs https://material.angularjs.org/latest/#/demo/material.components.gridList
      .iconSet('avatars', 'assets/svg/avatar-icons.svg', 24)
      .defaultIconSet('assets/svg/svg-sprite-action.svg', 24);

	  
 $httpProvider
     .interceptors.push(
        function(localStorageService, $q, $window) {
            return {
                request: function (config) {
                    config.headers = config.headers || {};
                    config.headers.Authorization = localStorageService.get('apikey');
                    return config || $q.when(config);
                },
                responseError: function (response) {
                    
                    if (response) {
                        if(response.status == 401 ) {
                            localStorageService.remove('apikey');
                            localStorageService.remove('user');
                            localStorageService.remove('uid');
                            $window.location = '#!/login';
                            return response;
                            //make the user login again
                        }
                        else if(response.status == 404) {
/*                            localStorageService.remove('apikey');
                            localStorageService.remove('user');
                            localStorageService.remove('company');   */                        
                            $window.location = '#/exception/404';
                        }
                        if (response.status == 403) {
                            localStorageService.remove('apikey');
                            localStorageService.remove('user');
                            localStorageService.remove('uid');                           
                            $window.location = '#/exception/403';
                        }

                    }
                    return $q.reject(response);
                }
            }
    })  	  
	  
	  
  }
  


})();

(function() {
  'use strict';

  angular
    .module('app')
    .config(config);

  /** @ngInject */
  function config($mdDateLocaleProvider, moment) {
// Example of a French localization.

    $mdDateLocaleProvider.shortDays = ['Du', 'Lu', 'Ma', 'Mi', 'Jo', 'Vi', 'Sa'];
    $mdDateLocaleProvider.firstDayOfWeek = 1;

    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'L', true);
      return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = function(date) {
       return moment(date).format('DD.MM.YYYY');
    }; 
      
    $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) {
      return 'Săptămâna ' + weekNumber;
    };      
      
    $mdDateLocaleProvider.msgCalendar = 'Calendar';
    $mdDateLocaleProvider.msgOpenCalendar = 'Deschide calendarul';      
      
}  

  

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/states/_main/listBottomSheet.template.html","<md-bottom-sheet class=md-list><md-list><md-list-item ng-repeat=\"item in libo.items\" role=link md-ink-ripple><md-button ng-click=libo.itemClick($index) layout-fill aria-label=label><md-icon md-svg-icon={{item.icon}} aria-label={{item.name}} style=float:left></md-icon><md-button-text>{{item.name}}</md-button-text></md-button><md-divider></md-divider><!--            </div>--></md-list-item></md-list></md-bottom-sheet>");
$templateCache.put("app/states/_main/main.html","<div ui-view=navleft></div><md-toolbar flex=none class=\"md-primary md-hue-1\"><span ui-view=toolbars></span></md-toolbar><span ui-view=top show-lg hide-sm hide-md hide-xs flex=none></span> <span ui-view=topMDSM hide-lg hide-sm show-md hide-xs flex=none></span> <span ui-view=content flex layout=column></span><section flex=5 layout=row><span style=\"background:navy; color:yellow; text-align:center\" flex><small>&copy; 2017, SIGN PORTAL SRL ARAD</small></span></section>");
$templateCache.put("app/states/apps/AppModalTemplate.html","<form name=addform><md-dialog aria-label=\"ADAUGA APLICATIE\"><form ng-cloak><md-toolbar><div class=md-toolbar-tools><h2>ADĂUGARE APLICAȚIE</h2><span flex></span><!--		delete forever--><md-button class=md-icon-button ng-show=vm.item.id ng-click=\"vm.action(\'remove\', vm.item)\"><md-icon md-svg-icon=action:ic_delete_forever_24px></md-icon><md-tooltip style=\"font-size:15px;padding:0 10px 20px 10px\">STERGE<br>APLICAȚIA</md-tooltip></md-button><md-button class=md-icon-button ng-click=\"vm.action(\'close\', null)\"><md-icon md-svg-src=navigation:ic_close_24px aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><section layout=column><md-input-container flex><label>Numele aplicației</label><input ng-model=vm.item.appName required></md-input-container><md-input-container flex><label>Descrierea aplicației</label><input ng-model=vm.item.appDesc required></md-input-container><md-input-container flex><label>Adresa URL a aplicației</label><input ng-model=vm.item.appUrl required></md-input-container></section></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=\"vm.action(\'create\', vm.item)\" ng-disabled=addform.$invalid aria-label=confirma ng-if=!vm.item.id>ADAUGĂ</md-button><md-button ng-click=\"vm.action(\'update\', vm.item)\" ng-disabled=addform.$invalid aria-label=confirma ng-if=vm.item.id>ACTUALIZEAZĂ</md-button></md-dialog-actions></form></md-dialog></form>");
$templateCache.put("app/states/apps/main.html","<md-content flex layout=column><md-toolbar class=\"md-primary md-hue-0\" flex=10><div class=md-toolbar-tools><!--		back button--><md-button class=md-icon-button ui-sref=index.main><md-icon md-svg-icon=navigation:ic_chevron_left_24px></md-icon><md-tooltip style=font-size:15px>ÎNAPOI</md-tooltip></md-button>&nbsp;<h4>APLICATII</h4><span flex></span><md-button class=md-icon-button ng-click=\"vm.action(\'remove\', vm.item)\"><md-icon md-svg-icon=content:ic_add_24px></md-icon></md-button></div></md-toolbar><md-content flex layout=row layout-align=center><md-content flex=100><md-list flex><!--					<md-subheader class=\"md-primary\">\r\n						<section layout=\"row\" flex=\"90\">\r\n							<span flex=\"5\"> ID</span>\r\n							<span flex=\"10\">NUME</span>\r\n							<span flex=\"40\">DESCRIERE </span>\r\n							<span flex=\"45\">ADRESA URL </span>\r\n						</section>\r\n					</md-subheader>--><md-list-item class=md-3-line ng-repeat=\"item in vm.apps\" ng-click=\"vm.action(\'update\', item)\"><div class=md-list-item-text><h3><strong>{{item.appName}}</strong></h3><h4>{{item.appDesc}}</h4><h4>{{item.appUrl}}</h4></div><md-divider></md-divider></md-list-item></md-list></md-content></md-content></md-content>");
$templateCache.put("app/states/exception/template.html","<md-content><md-card md-whiteframe=3><md-card-header><md-card-header-text><div class=md-title>Eroare {{vm.error.code}} - {{vm.error.short}}</div><div class=md-subtitle>{{vm.error.long}}</div></md-card-header-text><md-card-subheader-text class=md-subtitle></md-card-subheader-text></md-card-header><md-card-actions><md-button md-whiteframe=3 style=float:right ui-sref=index.main><md-icon md-svg-icon=action:ic_home_24px></md-icon><md-button-text ng-href=/ ></md-button-text></md-button></md-card-actions></md-card></md-content>");
$templateCache.put("app/states/login/loginForm.html","<md-toolbar class=\"md-primary md-hue-2\"><div style=text-align:center><h2><strong>{{vm.appData.name}}</strong></h2><h6>{{vm.appData.version}}</h6></div></md-toolbar><br><md-content><form name=clientLogin layout-fill><section layout=column layout-align=\"center center\"><span flex-gt-xs=25 flex-xs=90><md-card class=\"md-whiteframe-z2 md-padding\" flex><md-card-content layout=column layout-padding><div section layout=row layout-fill><span flex=5></span><md-separator></md-separator><md-input-container flex><md-icon md-svg-icon=action:ic_account_circle_24px></md-icon><input ng-model=user.username name=userName type=text placeholder=\"Nume utilizator\" required style=\"font-size:25px; font-weight:bold\"><div ng-messages=clientvm.user.username.$error><div ng-message=required>utilizarul este obligatoriu</div></div></md-input-container><span flex=5></span></div></md-card-content><md-card-content layout=column layout-padding><div section layout=row layout-fill><span flex=5></span><md-separator></md-separator><md-input-container flex><!--                        <md-icon md-svg-icon=\"action:ic_account_circle_24px\"> </md-icon>--><md-icon md-svg-icon=communication:ic_vpn_key_24px></md-icon><input type=password required ng-model=user.password type=text placeholder=Parola name=userPassword style=\"font-size:25px; font-weight:bold\"><div ng-messages=clientvm.user.password.$error><div ng-message=required>parola este obligatorie</div></div></md-input-container><span flex=5></span></div></md-card-content></md-card></span></section><div layout=row layout-padding><span flex></span><md-button class=\"md-primary md-hue-2\" ng-click=vm.submit(user) ng-disabled=clientLogin.$invalid aria-label=\"login button\"><span show-xs hide-gt-xs><md-icon md-svg-icon=notification:ic_enhanced_encryption_24px style=\"height:50vw; width:50vw\"></md-icon></span><span hide-xs show-gt-xs><md-icon md-svg-icon=action:ic_check_circle_24px style=\"height:10vw; width:10vw\"></md-icon></span></md-button><span flex></span></div></form></md-content>");
$templateCache.put("app/states/roles/RoleModalTemplate.html","<md-dialog aria-label=\"ADAUGA APLICATIE\"><form name=addrole flex=100><md-toolbar class=\"md-primary md-hue-0\"><div class=md-toolbar-tools><h2 ng-if=!vm.item.id>ADĂUGARE ROL</h2><h2 ng-if=vm.item.id>MODIFICARE ROL</h2><span flex></span><md-button class=md-icon-button ng-click=\"vm.action(\'remove\')\"><md-icon md-svg-src=action:ic_delete_forever_24px aria-label=\"Remove dialog\"></md-icon></md-button><md-button class=md-icon-button ng-click=\"vm.action(\'close\',null)\"><md-icon md-svg-src=navigation:ic_close_24px aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><section layout=column><md-input-container flex><label>Numele rolului</label><input ng-model=vm.item.roleName required></md-input-container><md-input-container flex><label>Descrierea rolului</label><input ng-model=vm.item.roleDesc required></md-input-container></section></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button ng-click=\"vm.action(\'create\')\" ng-disabled=addrole.$invalid aria-label=add ng-if=!vm.item.id>ADAUGĂ</md-button><md-button ng-click=\"vm.action(\'update\')\" ng-disabled=addrole.$invalid aria-label=mod ng-if=vm.item.id>MODIFICĂ</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/states/roles/main.html","<md-toolbar class=\"md-primary md-hue-0\" flex=10><div class=md-toolbar-tools><!--		back button--><md-button class=md-icon-button ui-sref=index.main><md-icon md-svg-icon=navigation:ic_chevron_left_24px></md-icon><md-tooltip style=font-size:15px>ÎNAPOI</md-tooltip></md-button>&nbsp; <span>ROLURI GENERICE </span><span flex></span><md-button ng-click=\"showSearch = !showSearch; filtru = null;\" aria-label=\"activate search\"><md-icon md-svg-src=action:ic_search_24px></md-icon></md-button><md-button class=md-icon-button aria-label=add ng-click=vm.action(null)><md-icon md-svg-src=content:ic_add_24px></md-icon></md-button></div></md-toolbar><!--cautare in toolbar separat pe dispozitive mici--> <input type=text ng-model=criteriu ng-change=\"filtru = criteriu\" placeholder=\"filtrare după nume\" flex=10 ng-show=\"showSearch == true\" class=md-padding><md-content flex><!--    {{vm.titulari}}--><!--    header--><md-list flex><!--        <md-subheader class = \"md-primary\">\r\n            <section layout = \"row\" flex = \"\">\r\n                <span flex = \"5\"> ID</span>\r\n                <span flex = \"20\">DENUMIRE ROL</span>\r\n				\r\n                <span flex = \"end\">DESCRIERE </span>\r\n            </section>\r\n        </md-subheader>--><md-list-item class=md-2-line ng-repeat=\"item in vm.roles\" ng-click=vm.action(item)><div class=md-list-item-text><h3><strong>{{ item.roleName }}</strong></h3><h4>{{item.roleDesc}}</h4></div><md-divider></md-divider></md-list-item></md-list></md-content>");
$templateCache.put("app/states/_main/partials/content.html","<br><section layout-gt-xs=row layout-xs=column><md-card flex-gt-xs=33><md-card-title><md-card-title-text><span class=md-headline>COMPANII</span></md-card-title-text></md-card-title><md-card-content><br><md-divider></md-divider>COMPANII ÎNSCRISE <strong class=red style=font-size:32px;padding:100px>{{vm.companies.length}}</strong></md-card-content></md-card><md-card flex-gt-xs=33><md-card-title><md-card-title-text><span class=md-headline>UTLIZATORI</span></md-card-title-text></md-card-title><md-card-content><br><md-divider></md-divider>COUNTURI UTILIZATORI: <strong class=red style=font-size:32px;padding:100px>{{vm.users.length}}</strong></md-card-content></md-card><md-card flex-gt-xs=33><md-card-title><md-card-title-text><span class=md-headline>ABONAMENTE</span></md-card-title-text></md-card-title><md-card-content><br><md-divider></md-divider><section layout=row flex><span flex=75>TOTAL ABONAMENTE: </span><span flex=end style=text-align:right><strong class=red style=font-size:32px>{{vm.subs.all.length}}</strong></span></section><md-divider></md-divider><section layout=row flex=100><span flex=75>ABONAMENTE ACTIVE: </span><span flex=end style=text-align:right><strong class=red style=font-size:32px>{{vm.subs.active.length}}</strong></span></section><md-divider></md-divider><section layout=row flex><span flex=75>ABONAMENTE EXPIRATE: </span><span flex=end style=text-align:right><strong class=red style=font-size:32px>{{vm.subs.expired.length}}</strong></span></section><section layout=row flex><span ng-repeat=\"i in vm.subs.expired\"><small><a ui-sref=index.subscription({id:i.id})>{{i.id}}</a></small></span></section><md-divider></md-divider><section layout=row flex><span flex=75>EXPIRĂ IN 30 DE ZILE: </span><span flex=end style=text-align:right><strong class=red style=font-size:32px>{{vm.subs.toExpire.length}}</strong></span></section><section layout=row flex><span ng-repeat=\"i in vm.subs.toExpire\"><small><a ui-sref=index.subscription({id:i.id})>{{i.id}}</a></small></span></section><md-divider></md-divider></md-card-content></md-card></section>");
$templateCache.put("app/states/_main/partials/navleft.html","<!--left navigation panel--><!--    <md-sidenav layout=\"column\"class=\"md-sidenav-left md-whiteframe-z5\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" style = \"height: 100vh\">--><md-sidenav layout=column class=\"md-sidenav-left md-whiteframe-z5\" md-component-id=left style=\"height: 100vh\" hide-lg><!--        user info panel--><md-toolbar class=\"animate-show md-whiteframe-z3 md-accent md-hue-3\" style=margin-top:2px><!-- title --><div class=md-toolbar-tools>{{vm.title}}</div></md-toolbar><md-content><!--        main menu--><md-card class=md-whiteframe-z5 layout-fill layout-padding layout=column><div flex=5></div><div ng-repeat=\"item in vm.frontPage\" flex ng-click=\"vm.toggleSidenav(\'left\')\" ui-sref={{item.state}}><md-card layout-fill class=md-whiteframe-z3 layout-align=\"center center\" flex style=\"background:{{item.bgColor}}; min-height:100px\"><i class=\"fa fa-3x fa-{{item.icon}}\" style=color:{{item.textColor}}></i><h1 style=\"font-size:15px; color:{{item.textColor}}\">{{item.name}}</h1></md-card></div><div flex=5></div></md-card></md-content></md-sidenav><!--end left navigation panel-->");
$templateCache.put("app/states/_main/partials/toolbars.html","<md-toolbar class=\"animate-show nd-short md-whiteframe-z3 md-primary md-hue-2\"><!-- title --><div class=md-toolbar-tools><!--            hamburger button on small screen--><!--        <md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'left\')\" hide-gt-md aria-label=\"Menu\">--><md-button class=md-icon-button ng-click=\"vm.toggleSidenav(\'left\')\" aria-label=Menu hide-lg show-xs><md-icon md-svg-icon=navigation:ic_menu_24px aria-label=Menu></md-icon></md-button><h1 hide-gt-sm hide-xs show-lg>{{vm.title}}</h1>&nbsp;<h6>{{vm.version}}</h6><span flex></span><md-button class=md-icon-button aria-label=config ui-sref=index.registru><md-icon md-svg-icon=maps:ic_local_library_24px></md-icon><md-tooltip md-toolbar-bottom style=\"padding:0 10px 25px 10px\"><h1>REGISTRU GENERAL</h1></md-tooltip></md-button><md-button class=md-icon-button aria-label=config ui-sref=index.settings><md-tooltip md-toolbar-bottom style=\"padding:0 10px 25px 10px\"><h1>CONFIGURARI</h1></md-tooltip><md-icon md-svg-icon=action:ic_settings_24px></md-icon></md-button><md-button class=md-icon-button aria-label=\"Open Settings\" ng-click=vm.showListBottomSheet($event)><md-tooltip md-toolbar-bottom style=\"padding:0 10px 25px 10px\"><h1>ALTE SETĂRI</h1></md-tooltip><md-icon md-svg-icon=navigation:ic_more_vert_24px aria-label=More></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/states/_main/partials/top.html","<div flex=100><md-card class=md-whiteframe-z5 layout-padding layout=row><div flex=5></div><div ng-repeat=\"item in vm.frontPage\" flex ng-click=\"a = !a\" ui-sref={{item.state}}><md-card layout-fill layout-padding class=md-whiteframe-z3 layout-align=\"center center\" flex style=background:{{item.bgColor}}><i class=\"fa fa-{{item.icon}} fa-2x\" style=color:{{item.textColor}}></i> <a style=color:{{item.textColor}}>{{item.name}}</a></md-card></div><div flex=5></div></md-card></div>");
$templateCache.put("app/states/_main/partials/topMD-SM.html","<div flex=100><md-card class=md-whiteframe-z5 layout-padding layout=row><div flex=5></div><div ng-repeat=\"item in vm.frontPage\" flex ng-click=\"a = !a\" ui-sref={{item.state}}><md-card layout-fill layout-padding class=md-whiteframe-z3 layout-align=\"center center\" flex style=background:{{item.bgColor}}><div layout=row><i class=\"fa fa-{{item.icon}}\" style=color:{{item.textColor}}></i> &nbsp; <a style=color:{{item.textColor}}>{{item.name}}</a></div></md-card></div><div flex=5></div></md-card></div>");}]);